import { defineStyleConfig } from '@chakra-ui/react';

import { CAPTION_CONFIG } from './constants';

export const CaptionStyleConfig = defineStyleConfig({
  baseStyle: {
    fontFamily: 'lato',
  },
  variants: CAPTION_CONFIG,
  defaultProps: {
    variant: 'Regular',
  },
});
